import { NgModule } from '@angular/core';
import { SharedUIModule } from '@shared/ui';
import {
  AntipatternPopupComponent,
  AntipatternPopupV2Component,
  FeedbackComponent,
} from './components';
import { FormsModule } from '@angular/forms';

const COMPONENTS = [
  AntipatternPopupComponent,
  AntipatternPopupV2Component,
  FeedbackComponent,
];

@NgModule({
  imports: [FormsModule, SharedUIModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class AntipatternModule {}
